import React from "react";
import { Row, Col, Dropdown, DropdownButton } from "react-bootstrap";
import { TutorSettingAction, ApplicationFormAction } from "../../redux/actions";
import { updateTutorSettings, getSetting } from "../../apis/tutors";
import { connect } from "react-redux";
import warning from "../../assets/icons/warning.png";
import { SettingHeader } from "./../TutorSetting/SpecificSettingComp";
import TeachAndCertModal from "../../components/modals/TeachAndCert.Modal";
import { InfoModal } from "./../../components/modals/InfoModal";
import RemoveCertificate from "../../components/modals/RemoveCertificate.Modal";

class TutorSettingDoctoralCertificate extends React.PureComponent {
	constructor() {
		super();

		this.state = {
			index: 0,
			files: [],
			open: false,
			show: false,
			show1: false,
			show2: false,
			isOpen: false,
			certificate: "",
			showAlert: false,
			qualification: "",
			qualifications: [],
			imageErrorMessage: "",
			slectedCertificate: "",
			fileError: false,
			certificateError: false,
			selectedDoctoralCertificate: "",
			doctoralCertificates: ["University Lecturer", "University Professor"],
			certificates: [
				"PGCE",
				"Teach First",
				"SCITT",
				"Graduate Teacher training Program",
				"Bachelor of Education",
				"University Lecturer",
				"University Professor"
			],
		};

	}

	cancel = () => {

		this.setState({ 
			files: [], 
			show: false, 
			fileError: false, 
			qualification: "", 
			certificateError: false
		});

	}

	save = () => {	

		const { files, fileError, qualification, qualifications, certificateError } = this.state;

		if( !qualification && !certificateError ) {

			this.setState({ certificateError: true })

		}
		else if( !files.length && !fileError && qualification ) {
			
			this.setState({ fileError: true })

		}
		else if( qualification && files.length ) {
			
			let newQualification = { files: files, qualification: qualification, verified: false };

			this.setState({ 
				files: [], 
				show: false, 
				fileError: false, 
				qualification: "", 
				certificateError: false, 
				qualifications: [...qualifications, newQualification]
			});

		}

	}

	remove = (index) => {

		let qualifications = [...this.state.qualifications];

		qualifications.splice(index, 1);

		this.setState({ qualifications: [...qualifications], open: false })
	}

	fileupload = (file) => {

		if (file.target.files[0] !== null) {

			const { files } = this.state;

			this.setState({ files: [...files, file.target.files[0]] })

		}
		
	}

	onCloseFile = (index) => {

		let files = [...this.state.files];

		files.splice(index, 1);

		this.setState({ files: [...files] })

	}

	componentDidMount = () => {
		let { selectedDoctoralCertificate, certificate } = this.state;
		const { tutorSettingData } = this.props;
		let certificates = tutorSettingData?.tutorDetails?.certificates;
		let supportingDocs = tutorSettingData?.tutorDetails?.supportingDocs.length
		? tutorSettingData?.tutorDetails?.supportingDocs[0]
		: {};
		selectedDoctoralCertificate = certificates?.doctoralDegree?.length
		? certificates?.doctoralDegree[0]
		: {};
		certificate = certificates?.teachingAndEducation?.length
		? certificates?.teachingAndEducation[0]
		: {};
		this.setState({
		selectedDoctoralCertificate,
		certificate,
		supportingDocs,
		});
	}

	componentDidUpdate = (prevProps) => {
		let { selectedDoctoralCertificate, certificate } = this.state;
		const { tutorSettingData } = this.props;
		if (
		JSON.stringify(prevProps.tutorSettingData) !==
		JSON.stringify(tutorSettingData)
		) {
		let certificates = tutorSettingData?.tutorDetails?.certificates;
		selectedDoctoralCertificate = certificates?.doctoralDegree?.length
			? certificates?.doctoralDegree[0]
			: {};
		certificate = certificates?.teachingAndEducation?.length
			? certificates?.teachingAndEducation[0]
			: {};
		let supportingDocs = tutorSettingData?.tutorDetails?.supportingDocs.length
			? tutorSettingData?.tutorDetails?.supportingDocs[0]
			: {};

		this.setState({
			selectedDoctoralCertificate,
			certificate,
			supportingDocs,
		});
		}
	}

	onUpdateTutorSettings = () => {
		this.setState({
		loader: true,
		});
		const {
		certificate,
		selectedDoctoralCertificate,
		supportingDocs,
		} = this.state;
		let user = JSON.parse(localStorage.getItem("userDetail"));
		let user_id = user.user.userId;
		let updateSettingParam = {
		updateSetting: {
			supportingDocs: [supportingDocs],
			certificates: {
			teachingAndEducation: [certificate],
			doctoralDegree: [selectedDoctoralCertificate],
			},
		},
		};
		updateTutorSettings(updateSettingParam)
		.then((res) => {
			getSetting({ user_id })
			.then((res) => {
				this.props.TutorSettingStoreData(res.data);
				this.setState({
				tutorSettingDataState: {},
				loader: false,
				});
				InfoModal("Updates", "Successfully Update");
			})
			.catch((err) => console.log(err));
		})
		.catch((err) => console.log(err, "==="));
	}

	render() {
		const { doctoralCertificateOpenModal, onclose } = this.props;
		const { updateState, iscompletedForm } = this.props;
		const {
			open,
			show,
			show1,
			show2,
			files,
			index,
			loader,
			isOpen,
			fileError,
			dBSCertUrl,
			certificate,
			certificates,
			qualification,
			qualifications,
			supportingDocs,
			certificateError,
			doctoralCertificates,
			selectedDoctoralCertificate,
		} = this.state;

		let warningError = (

			<img src={warning} alt="warning" width="14px" height="14px" style={{ marginRight: "6px" }} />

		);

		return (
			<div className="container">
				<Row className="flex-center-center">
					<Col lg={8} md={8} sm={12} xs={12} className="tutor-setting-doctoral-certificate">
						<SettingHeader
							settingName={"Teaching and doctoral certificates"}
						headerTitle={"Teaching, doctoral and other certificates"}
						headerDesciption={`Upload supporting documents to verify your teaching and doctoral degree qualification`}
							goToAccount={() => this.props.history.push("/tutor-setting")}
						/>
						<TeachAndCertModal
							isOpen={isOpen}
							certificates={certificates}
							onHide={ () => this.setState({ isOpen: false }) }
							onSave={ (qualification) => this.setState({ qualification: qualification }) }
						/>
						<RemoveCertificate
							open={open}
							index={index}
							remove={ (index) => this.remove(index) }
							close={ () => this.setState({ open: false }) }
						/>
						{ !show ? (
							<div>
								<div className="flex-between-start">
									<label className="label">
										Education, doctoral degree or other earned certificates
									</label>
									<span className="btn-a" onClick={ () => this.setState({ show: true }) }>Add</span>
								</div>
								{
									qualifications && qualifications.length ? 
										qualifications.map( ( qualification, index ) => {
											return (
												<div className="flex-between-center mt-3">
													<p className="Text-messages m-0">
														{ qualification.qualification }<span className="dot"></span>
														<span style={{ color: !qualification.verified ? "#fa4a4a" : "" }}>
															{ qualification.verified ? "Verified" : "Pending verification" }
														</span>
													</p>
													<span className="btn-a" onClick={ () => this.setState({ open: true, index: index }) }>Remove</span>
												</div>
											)
										} ) : <p className="Text-messages">None provided</p>
								}
								<hr/>	
							</div>
						) : (
							<div>
								<div className="flex-between-start">
									<label className="label">
										Education, doctoral degree or other earned certificates
									</label>
									<span className="btn-a" onClick={this.cancel}>Cancel</span>
								</div>
								{
									qualifications && qualifications.length ? 
										qualifications.map( ( qualification, index ) => {
											return (
												<div className="flex-between-center mt-3">
													<p className="Text-messages m-0">
														{ qualification.qualification }<span className="dot"></span>
														<span style={{ color: !qualification.verified ? "#fa4a4a" : "" }}>
															{ qualification.verified ? "Verified" : "Pending verification" }
														</span>
													</p>
													<span className="btn-a" onClick={ () => this.setState({ open: true, index: index }) }>Remove</span>
												</div>
											)
										} ) : ""
								}
								{ qualifications && qualifications.length ? <hr/> : "" }
								<Dropdown onClick={() => this.setState({ isOpen: true }) }>
									<Dropdown.Toggle className={ !qualification && certificateError ? "errorD" : "" }>
										<span className={ !qualification && certificateError ? "errorS" : "" }>
											{ qualification ? qualification : "Select certificate" }
											<i className="fa fa-angle-down"></i>
										</span>
									</Dropdown.Toggle>
								</Dropdown>
								{
									!qualification && certificateError ? (
										<div className="error">
											{ warningError }
											Add earned education, doctoral degree or other certificate
										</div>	
									) : ""												
								}
								<label
									className="label mt-3" 
									style={{ color: !files.length && fileError ? "#fa4a4a" : "" }}
								>
									Add supporting documents to verify your qualifications, supporting documents 
									will appear as verified on your tutor profile.
								</label>
								<p 
									className="certfcate_small-p"
									style={{ color: !files.length && fileError ? "#fa4a4a" : "" }}
								>
									<i className="fa fa-lock"></i>
									This information is used to verify and award you with a badge on your 
									tutor profile and is not shared with other users of Askademia
								</p>
								<ul className="files-list">
									{ 
										files?.length ? files.map((file, index) => {
											return (
												<li key={index}>
													<span> {file?.name}</span>
													<i className="mdi mdi-close" onClick={ () => this.onCloseFile(index) }></i>
												</li>
											)
										}) : ""
									}
								</ul>
								<label className="add-file" style={{ color: !files.length && fileError ? "#fa4a4a" : "" }}>
									<i className="fa fa-plus"></i>
									Add { files.length ? "additional supporting document" : "File" }
									<input type="file" accept=".pdf, .jpeg, .jpg" onChange={ (f) => this.fileupload(f) }/>
								</label><br/>
								<button className="save" onClick={this.save}>save</button>
							</div>
						)}
					</Col>
				</Row>
			</div>
		);
	}
	
}

const mapStateToProps = (state) => {
	const {
		TutorSettingReducer: { tutorSettingData },
	} = state;

	return {
		tutorSettingData,
	};
};
const mapDispatchToprops = (dispatch) => {
	return {
		TutorSettingStoreData: (payload) =>
			dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
		ImageUploadAction: (payload) =>
			dispatch(ApplicationFormAction.ImageUploadAction(payload)),
	};
};

export default connect( mapStateToProps, mapDispatchToprops )(TutorSettingDoctoralCertificate);
